// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addCol {
    justify-content: space-between;
}

.colName {
    width: 30%;
    margin-left: 5px;
    min-width: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/dataoperations/addcolumns/addcolumns.settings.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".addCol {\n    justify-content: space-between;\n}\n\n.colName {\n    width: 30%;\n    margin-left: 5px;\n    min-width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
